import script from "./Tabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tabs.vue?vue&type=script&setup=true&lang=ts"

import "./Tabs.vue?vue&type=style&index=0&id=2d3064e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d3064e0"]])

export default __exports__